import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  justify-content: center;
  padding-block-start: 32px;
`;

const Content = styled.div`
  text-align: center;
`;

const PageLoadError = () => (
  <Root data-testid="page-load-error">
    <Content>
      <h1>
        <FormattedMessage id="error-page.header" />
      </h1>
      <p>
        <FormattedMessage id="error-page.description" />
      </p>
    </Content>
  </Root>
);

export default PageLoadError;
